module.exports = __webpack_public_path__ + "static/img/svipri.509d39e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/svipri.png
// module id = YWke
// module chunks = 1